/*
   PROPS:
      alertMessages     [alertMessage, alertMessage, ...]
         Where
            alertMessage = {text, type}
            OR String (default type = "danger")

            type can either be one of the following:
               primary
               secondary
               success
               danger
               warning
               info
               light
               dark
       handleCloseAlert(index)
 */
import React, { useEffect, useState } from 'react';

import { UncontrolledAlert } from 'reactstrap';

const FormNotifications = ({ alertMessages, handleCloseAlert }) => {
   const [offset, setOffset] = useState(0);

   useEffect(() => {
      setOffset(offset + alertMessages.length);
   }, [alertMessages]);

   if (!alertMessages || alertMessages.length === 0) {
      return null;
   } else {
      return (
         <>
            {
               alertMessages.map((message, index) => {
                  if (typeof message === 'string') {
                     return (
                        <UncontrolledAlert color='danger' className='alert-outline-colored' key={index + offset}>
                           <div className='alert-message'>
                              {message}
                           </div>
                        </UncontrolledAlert>
                     );
                  } else if (typeof message === 'object') {
                     return (
                        <UncontrolledAlert color={message.type} className={`alert-outline-colored`} key={index + offset} toggle={() => handleCloseAlert(index)}>
                           <div className='alert-message'>
                              {message.text}
                           </div>
                        </UncontrolledAlert>
                     );
                  } else {
                     return null;
                  }
               })
            }
         </>
      );
   }
};

export default FormNotifications;
